module.exports = __webpack_public_path__ + "static/media/favourite-full.0568f2ac.svg";